import { useState } from 'react'
import PartPicker from 'components/PartPicker'
import useConvertPartsHandler from '../../effects/convert-parts'
import { EuiFieldNumber, EuiFormRow, EuiButton } from '@equipmentshare/ds2'
import { Part } from 'graphql'

import styles from './convert-parts.module.css'
import { heapEvent } from '@equipmentshare/heaper'

export type ConvertPartsProps = {
  storePart: any,
	onCancel: () => void,
	onSuccess: () => void,
}

export default function ConvertParts( { storePart, onCancel, onSuccess }: ConvertPartsProps ) {
	const convertParts = useConvertPartsHandler()

	const [ quantity, setQuantity ] = useState<number | ''>( '' )
	const [ part, setPart ] = useState<Part>()
	const [ isSaving, setIsSaving ] = useState( false )

	const handleQuantityChange = ( event: React.ChangeEvent<HTMLInputElement> ) => {
		setQuantity( parseInt( event.target.value.replace( /\D/g, '' ), 10 ) || '' )
	}
	const handlePartChange = ( _id: number, selectedPart?: Part ) => setPart( selectedPart )

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Convert Items Modal - Click - Submit', {} )
		setIsSaving( true )
		return await convertParts( storePart, part?.id?.toString() ?? '', quantity !== '' ? quantity : 0 )
			.then( onSuccess )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Convert Items Modal - Click - Cancel', {} )
		onCancel()
	}

	const isValid = !!quantity && !!part

	return (
		<div className={styles.container}>
			<div className={styles.form}>
				<div className={styles.row}>
					<EuiFormRow label="Quantity to convert">
						<EuiFieldNumber
							id="quantity"
							onChange={handleQuantityChange}
							value={quantity}
						/>
					</EuiFormRow>
				</div>

				<div className={styles.row}>
					<PartPicker
						id="part"
						label="Convert to item"
						onChange={handlePartChange}
						selectedPart={part}
					/>
				</div>

				<div className={styles.row}>
					Converting items will deplete the quantity of the chosen item and increase the quantity of the item you are converting it to.
				</div>
			</div>

			<div className={styles.buttonContainer}>
				<EuiButton
					color="text"
					onClick={handleCancel}
				>
          Cancel
				</EuiButton>
				<EuiButton
					fill
					color="primary"
					className="submit"
					onClick={handleSubmit}
					isLoading={isSaving}
					isDisabled={!isValid}
				>
          Submit
				</EuiButton>
			</div>
		</div>
	)
}
